// extracted by mini-css-extract-plugin
module.exports = {"date":"ProcedureTableInfo_date__2Fg16","head":"ProcedureTableInfo_head__WWdem"};